@file:Suppress("DEPRECATION")
package org.example.newportfolio.components.sections.products

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.layout.SimpleGrid
import com.varabyte.kobweb.silk.components.layout.numColumns
import com.varabyte.kobweb.silk.components.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.components.style.toModifier
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import org.example.newportfolio.components.sections.products.components.ProductItem
import org.example.newportfolio.components.sections.works.components.WorkItemsSimpleGridVariant
import org.example.newportfolio.components.widgets.section.SectionContainer
import org.example.newportfolio.models.Product
import org.example.newportfolio.models.Section
import org.example.newportfolio.theme.fonts.*
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px

@Composable
fun ProductsSection() {
    val breakpoint = rememberBreakpoint()
    SectionContainer(
        modifier = Modifier,
        section = Section.Products,
        verticalArrangement = Arrangement.Top,
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        TextContent(breakpoint = breakpoint)
        SimpleGrid(
            numColumns = numColumns(base = 1, sm = 1, md = 1, lg = 1, xl = 2),
            modifier = Modifier.fillMaxWidth()
                .maxWidth(1200.px)
                .padding(leftRight = 20.px)
                .margin(top = 4.cssRem),
            variant = WorkItemsSimpleGridVariant
        ) {
            // Stagger the product cards as the grid enters the viewport.
            // index % 8 because animations.css only ships stagger-0..7.
            Product.entries.forEachIndexed { index, product ->
                ProductItem(
                    product = product,
                    modifier = Modifier
                        .fillMaxWidth()
                        .classNames("scroll-reveal", "stagger-${index % 8}")
                )
            }
        }
    }
}

@Composable
private fun TextContent(
    breakpoint: Breakpoint,
) {
    Column(
        modifier = Modifier
            .margin(top = 8.5.cssRem)
            .classNames("scroll-reveal"),  // section heading fades up on scroll-in
        verticalArrangement = Arrangement.Center,
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        SpanText(
            modifier = TextStyle.toModifier(DisplayTextStyle, TextStylePrimaryColor).textAlign(TextAlign.Center),
            text = "My SaaS Products"
        )
        SpanText(
            modifier = TextStyle.toModifier(SubDisplayTextStyle, TextStyleSecondaryColor)
                .maxWidth(if (breakpoint >= Breakpoint.SM) 75.percent else 100.percent)
                .margin(top = 1.cssRem)
                .textAlign(TextAlign.Center),
            text = "Explore the independent products and platforms I've built and launched from scratch."
        )
    }
}
